import * as React from 'react';
import { Phone, ArrowRightLeft, GitMerge, Mail } from 'lucide-react';
import { cn } from '@/lib/utils';

export type MarkerType = 'prospect' | 'migrate' | 'mutualize' | 'email';

const config: Record<MarkerType, { icon: React.ComponentType<{ className?: string }>; label: string; vars: string }> = {
  prospect: {
    icon: Phone,
    label: 'démar.',
    vars:
      'data-[active=true]:bg-amber-100 data-[active=true]:text-amber-700 data-[active=true]:border-amber-600 data-[active=true]:dark:bg-amber-950/60 data-[active=true]:dark:text-amber-300 ' +
      'border-amber-600/40 text-amber-700 bg-amber-50/60 dark:border-amber-400/40 dark:text-amber-300 dark:bg-amber-950/30',
  },
  migrate: {
    icon: ArrowRightLeft,
    label: 'migrer',
    vars:
      'data-[active=true]:bg-blue-100 data-[active=true]:text-blue-700 data-[active=true]:border-blue-600 data-[active=true]:dark:bg-blue-950/60 data-[active=true]:dark:text-blue-300 ' +
      'border-blue-600/40 text-blue-700 bg-blue-50/60 dark:border-blue-400/40 dark:text-blue-300 dark:bg-blue-950/30',
  },
  mutualize: {
    icon: GitMerge,
    label: 'mutu.',
    vars:
      'data-[active=true]:bg-violet-100 data-[active=true]:text-violet-700 data-[active=true]:border-violet-600 data-[active=true]:dark:bg-violet-950/60 data-[active=true]:dark:text-violet-300 ' +
      'border-violet-600/40 text-violet-700 bg-violet-50/60 dark:border-violet-400/40 dark:text-violet-300 dark:bg-violet-950/30',
  },
  email: {
    icon: Mail,
    label: 'email',
    vars:
      'data-[active=true]:bg-emerald-100 data-[active=true]:text-emerald-700 data-[active=true]:border-emerald-600 data-[active=true]:dark:bg-emerald-950/60 data-[active=true]:dark:text-emerald-300 ' +
      'border-emerald-600/40 text-emerald-700 bg-emerald-50/60 dark:border-emerald-400/40 dark:text-emerald-300 dark:bg-emerald-950/30',
  },
};

export type MarkerToggleProps = {
  type: MarkerType;
  active: boolean;
  onToggle?: () => void;
  title?: string;
  showLabel?: boolean;
  size?: 'sm' | 'md';
};

export function MarkerToggle({ type, active, onToggle, title, showLabel = true, size = 'sm' }: MarkerToggleProps) {
  const c = config[type];
  const Icon = c.icon;
  return (
    <button
      type="button"
      data-active={active}
      onClick={onToggle}
      title={title ?? c.label}
      aria-pressed={active}
      className={cn(
        'inline-flex items-center gap-1 rounded-full border font-semibold transition-all opacity-65 hover:opacity-100 data-[active=true]:opacity-100 data-[active=true]:shadow-sm',
        size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs',
        c.vars
      )}
    >
      <Icon className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} />
      {showLabel && <span>{c.label}</span>}
    </button>
  );
}
